//  icons
import {

  FiLinkedin,
  FiPhone,
  FiGithub,
  FiMail,
  FiMapPin,
} from 'react-icons/fi';


// projects images
import Project1 from './assets/img/projects/n1.png';
import Project2 from './assets/img/projects/g1.png';
import Project3 from './assets/img/projects/1.png';
import Project4 from './assets/img/projects/ignite.PNG';
import Project5 from './assets/img/projects/skinstore1.png';
import Project6 from './assets/img/projects/refer.PNG';
import Project7 from './assets/img/projects/freecollage.PNG';
import Project8 from './assets/img/projects/Foodweb.png';



// skills images
import SkillImg1 from './assets/img/skills/html5.png';
import SkillImg2 from './assets/img/skills/css3.png';
import SkillImg3 from './assets/img/skills/js.png';
import SkillImg4 from './assets/img/skills/reactjs.png';
import SkillImg5 from './assets/img/skills/Redux1.png';
import SkillImg6 from './assets/img/skills/nodejs.png';
import SkillImg7 from './assets/img/skills/git.png';
import SkillImg8 from './assets/img/skills/Mdb.png';

// testimonial images


// navigation
export const navigation = [
  {
    name: 'home',
    href: 'home',
  },
  {
    name: 'about',
    href: 'about',
  },
  {
    name: 'project',
    href: 'portfolio',
  },
  {
    name : 'experience',
    href : 'experience',
  },
  {
    name: 'skills',
    href: 'skills',
  },
  // {
  //   name: 'testimonials',
  //   href: 'testimonials',
  // },
  {
    name: 'contact',
    href: 'contact',
  },
];

// social
export const social = [
  {
    icon: <FiLinkedin />,
    href: 'https://www.linkedin.com/in/jaya-vishwakarma-312418225/',
    target:"_blank"
  },
  {
    icon: <FiMail />,
    href: 'mailto:Jayavish423@gmail.com',
    target:"_blank"
  },
  {
    icon: <FiGithub />,
    href: 'https://github.com/Jaya8277',
    target:"_blank"
  },
  {
    icon: <FiMapPin />,
    href: 'https://goo.gl/maps/jAdeuwBwUGxf64ao8',
    target:"_blank"
  },
];

// companies

// projects
export const projectsData = [
  {
    id: '8',

    image: Project8,
    name: 'Food Odering ',
    category: 'Solo Projects',
    info:"A React.js and Redux-based mini project for online food ordering, featuring user authentication, category-wise menus, detailed food pages, and a dynamic shopping cart. Simplified for learning and showcasing modern web development practices.",
    tech:"ReactJS | Redux-toolkit | Axios",
    github:"https://github.com/Jaya8277/Food_Web",
    live:"https://food-web-c2e090.netlify.app/",
  },
  {
    id: '5',

    image: Project5,
    name: 'SkinStore ',
    category: 'Team Projects',
    info:"  In this website where we can buy all types of skincare and makeup products, It is a website where you can buy a lot of skincare products, beauty products which will enhance your skin. The product available on this website is not only for girls but for men as well.",
    github:"https://github.com/Jaya8277/CW-project",
    live:"https://epic-swanson-c038fa.netlify.app/",
    tech:"Javascript| HTML | CSS |Bootstarp"
  },

  

  {
    id: '1',
    image: Project1,
    name: 'Nordstrom',
    category: 'Team Projects',
    info:"This project is a clone of Nordstrom Fashion website which provides Men's, Women's & Kid's Clothing products.. This is a E-commerce website where we applied Front-end and added similar features.",
    github:"https://github.com/Jaya8277/NordstromRack",
    live:"https://delightful-medovik-a1459f.netlify.app/",
    tech:"React | Bootstrap | Redux | Material UI "
    
  
  },
  {
    id: '2',
    image: Project2,
    name: 'Groww',
    category: 'Team Projects',
    info:" This project is a clone of Groww   E-commerce website you might have seen the Groww Website, where investors can trade and invest in Stocks and Mutual funds...",
    github:"https://github.com/Jaya8277/Groww-website/tree/main/Team-GROWW-main",
    live:"https://remarkable-sopapillas-78f075.netlify.app/",
    tech:"HTML | CSS | Javascript | BOOTSTRAP | NODE JS | ReactJS  "
  },
  {
    id: '3',
    image: Project3,
    name: 'Traking Time',
    category: 'Team Projects',
    info:" It is a platform that provides the business with an efficient way to manage time which in turn enables them to manage their projects and improve productivity. Timetracking.co also acts as a platform that connects the user to multiple project management and time tracking software.",
    github:"https://github.com/Jaya8277/stoic-sack-3017",
    live:"https://stoic-sack-3017.netlify.app/",
    tech:"React | Redux | CSS | NodeJs  "
  },
  {
    id: '4',

    image: Project4,
    name: 'IgniteEducation ',
    category: 'Solo Projects',
    info:"Ignite Education number one online learning platfrom for all computer science students and every leaner, ignite give you more opportunity for great learning and great skiles Ignite Education Number One Online Learning Platfrom For All Computer Science Students And Every Leaner, 😊",
    github:"https://github.com/Jaya8277/IgniteProject",
    live:"https://ignite-site-8463.netlify.app/",
    tech:"HTML | CSS | Javascript| Bootstrap "
  },
  {
    id: '6',

    image: Project6,
    name: 'TuteDude Referal  ',
    category: 'Solo Projects',
    info:"This is a referal page like a landing page. This referral sends someone somewhere, often for help or advice. You'll need a referral from your Friends in order to see a specialist. You could also receive a referral for a job, if someone passes along your application",
    github:"https://github.com/Jaya8277/Landing_Page_Assign",
    live:"https://reliable-tapioca-3288cf.netlify.app/",
    tech:"HTML | CSS"
  },

  {
    id: '7',

    image: Project7,
    name: 'FreeCollage',
    category: 'Solo Projects',
    info:"CollegeSpace is a socio-economic portal available to all students and alumni of NSIT. The CS initiative was launched on 4th July, 2011 with the motive of making accessible each and every single piece of information pertaining to NSIT on an online platform.",
    github:"https://github.com/Jaya8277/FreeCollageWebsite/tree/main/project",
    live:"https://free-collage-website.netlify.app/",
    tech:"HTML | CSS | Bootstrap "
  },


];

// projects
export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'Team Projects',
  },
  {
    name: 'Solo Projects',
  }
];

// skill
export const skills = [
  {
    image: SkillImg1,
  },
  {
    image: SkillImg2,
  },
  {
    image: SkillImg3,
  },
  {
    image: SkillImg4,
  },
  {
    image: SkillImg5,
  },
  {
    image: SkillImg6,
  },
  {
    image: SkillImg7,
  },
  {
    image: SkillImg8,
  },
];

// services


// testimonials

// contact
export const contact = [
  {
    icon: <FiMail />,
    title: 'Have a question?',
    subtitle: 'I am here to help you.',
    description: 'Jayavish423@gmail.com',
  },
  {
    icon: <FiMapPin />,
    title: 'Current Location',
    subtitle: 'Jaunpur,UttarPradesh',
    // description: 'Serving clients worldwide',
  },
  {
    icon: <FiPhone />,
    title: 'Mobile Number',
    subtitle: '8881182866',
  }
];
